import React from "react";

type RightArrowButtonProps = {
  onClick?: () => void;
  label?: string;
  className?: string;
};

const RightArrowButton: React.FC<RightArrowButtonProps> = ({
  onClick,
  label = "Next",
  className
}) => {
  return (
    <div onClick={onClick} className={className}>
      <span>{label}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </div>
  );
};

export default RightArrowButton;
